import { Provider, Type } from '@angular/core';

import { ErrorLogger } from './error-logger.model';
import { ERROR_LOGGERS } from './error-loggers.token';

export function provideErrorLoggers(loggers: Type<ErrorLogger>[]): Provider[] {
  return loggers.map((logger) => ({
    multi: true,
    provide: ERROR_LOGGERS,
    useClass: logger,
  }));
}
